// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"094e8688","464":"b6d6615b","631":"a536d2ef","725":"3b5b0fe5","828":"1ba895e8"}[chunkId] + ".chunk.js";
};